<template>
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: '20px' }">
    <a-tabs v-model="dataForm.manager_type" @change="callback">
      <a-tab-pane key="1" tab="我的客户"> </a-tab-pane>
      <a-tab-pane key="2" tab="共享客户" force-render> </a-tab-pane>
    </a-tabs>
    <a-form layout="inline" :form="dataForm" @submit="getDataList" class="pb-10">
      <a-form-item label="客户姓名">
        <a-input v-model="dataForm.customer_name" placeholder="请输入客户姓名"></a-input>
      </a-form-item>
      <a-form-item label="客户手机号">
        <a-input v-model="dataForm.customer_phone" placeholder="请输入客户手机号"></a-input>
      </a-form-item>
      <a-form-item label="会员合同">
        <a-select v-model="dataForm.contract" style="width: 120px" placeholder="请选择" allowClear>
          <a-select-option value="1"> 已签署 </a-select-option>
          <a-select-option value="2"> 未签署 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="会员状态">
        <a-select v-model="dataForm.vip" style="width: 120px" placeholder="请选择" allowClear>
          <a-select-option value="1"> 已入会 </a-select-option>
          <a-select-option value="2"> 未入会 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="缴费时间">
        <a-range-picker @change="onChangeTime" allowClear value-format="yyyy/MM/DD" />
      </a-form-item>
      <a-form-item label="入会渠道">
        <a-select v-model="dataForm.comefrom" style="width: 120px" placeholder="请选择" allowClear>
          <a-select-option value="1"> 后台手动录入 </a-select-option>
          <a-select-option value="2"> 客户手动录入 </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
      </a-form-item>
      <a-form-item v-if="dataForm.manager_type === '1'" v-permission="['admin:customer:create']">
        <a-button type="primary" @click="addOrUpdateHandleJoin()">邀请客户入会</a-button>
      </a-form-item>
      <a-form-item v-if="dataForm.manager_type === '1'" v-permission="['admin:customer:create']">
        <a-button type="primary" @click="addOrUpdateHandle()">新增客户</a-button>
      </a-form-item>
      <a-form-item v-if="dataForm.manager_type === '1'">
        <a-button type="danger" @click="addShare()" :disabled="selectedRowKeys.length == 0">新增共享</a-button>
      </a-form-item>
    </a-form>
    <a-table :columns="columns" :data-source="dataList" :pagination="false" rowKey="customer_id"
      :loading="dataListLoading" :filterMultiple="dataForm.manager_type === '1'" :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }" :scroll="{ x: 1550 }">
      <template slot="customer_name" slot-scope="customer_name, row">

        <a-tooltip>
          <template slot="title">
            由我发起共享的客户
          </template>
          <span style="
            background: #1890ff;
            color: #fff;
            padding: 4px 4px 4px 6px;
            border-radius: 50%;
            font-size: 12px;
            margin-right: 4px;
          " v-if="row.managerChildren.length > 0">
            共
          </span>

        </a-tooltip>
        <a-button @click="CustomerDetail(row)" type="link" class="p-0 btn-edit"
          style="font-size: 16px;font-weight: bold;">{{
            customer_name
          }}</a-button>

      </template>
      <template slot="followlogs" slot-scope="followlogs">
        <div v-if="followlogs.length > 0">
          <a-icon type="snippets" style="color: #1890ff;font-size: 18px; margin-right: 5px" />{{
            followlogs[0].followlog_content }}
        </div>
        <div v-else style="color: #999">
          <!-- <a-icon
            type="snippets"
            style="font-size: 18px; margin-right: 5px"
          />  -->
          <span>暂无记录</span>
        </div>
      </template>
      <template slot="contract" slot-scope="contract">
        <a-tag :color="contract == 1 ? 'green' : 'red'">{{ contract == 1 ? '已签署' : contract == 2 ? '未签署' : '未录入'
        }}</a-tag>
      </template>
      <template slot="memberChildren" slot-scope="memberChildren">
        <div v-if="memberChildren.length > 0">
          <a-tag color="blue" v-for="v in memberChildren">{{ v.vip_key }}</a-tag>
        </div>
        <a-tag color="red" v-else>未入会</a-tag>
      </template>
      <template slot="action" slot-scope="text, row">
        <a-button type="link" @click="CustomerDetail(row)">查看客户档案</a-button>
        <a-button type="link" style="color: red" @click="deleteHandle(row.customer_id)"
          v-permission="['admin:customer:delete']" v-if="dataForm.manager_type === '1'">删除</a-button>
      </template>
    </a-table>
    <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
      :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange" @change="pageCurrentChangeHandle" />
    <Customer ref="customer" @ok="query" @newCustomerid="newCustomerid"></Customer>
    <AddCustomer ref="addOrUpdate" @ok="getDataList"></AddCustomer>
    <AddCustomerShare ref="addCustomerShare" @ok="query"></AddCustomerShare>
  </a-card>
</template>

<script>
import viewModule from "@/mixins/view-module";
import Customer from "@/components/Customer/index.vue";
import AddCustomer from "./components/addCustomer.vue";
import AddCustomerShare from "@/components/AddCustomerShare/index.vue";
export default {
  mixins: [viewModule],
  components: {
    Customer,
    AddCustomer,
    AddCustomerShare,
  },
  activated() {
    if (!!this.beforCustomerid) {
      this.$refs.customer.visible = true
      this.$refs.customer.resetlist()
    }
  },
  data() {
    return {
      beforCustomerid: "",
      dataForm: {
        customer_name: "",
        customer_phone: "",
        contract: undefined,
        vip: undefined,
        manager_type: "1",
        comefrom: undefined
      },
      selectedRowKeys: [],
      selectedRow: [],
      mixinViewModuleOptions: {
        getDataListURL: "/admin/customer/pageself",
        deleteURL: "/admin/customer/delete",
      },
      columns: [
        {
          title: "姓名",
          dataIndex: "customer_name",
          scopedSlots: { customRender: "customer_name" },
          width: 150,
          fixed: 'left'
        },
        {
          title: "手机号",
          dataIndex: "customer_phone",
          width: 160,
          fixed: 'left'
        },
        {
          title: "是否签署会员合同",
          dataIndex: "contract",
          scopedSlots: { customRender: "contract" },
          width: 160
        },
        // {
        //   title: "重要程度",
        //   dataIndex: "grade",
        //   scopedSlots: { customRender: "grade" },
        //   width: 100
        // },
        {
          title: "最新跟进记录",
          width: 200,
          dataIndex: "followlogs",
          scopedSlots: { customRender: "followlogs" },
        },
        {
          title: "会员等级",
          dataIndex: "memberChildren",
          scopedSlots: { customRender: "memberChildren" },
          width: 200
        },
        {
          title: "身份证号",
          dataIndex: "id_no",
          width: 200
        },
        {
          title: "性别",
          dataIndex: "gender_text",
          width: 80
        },
        // {
        //   title: "初次入会时间",
        //   dataIndex: "first_jointime",
        //   width: 200
        // },
        {
          title: "创建时间",
          dataIndex: "create_time",
          width: 200
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 240
        },
      ],
    };
  },
  methods: {
    CustomerDetail(row) {
      this.$refs.customer.init(row);
    },
    newCustomerid(id) {
      this.beforCustomerid = id
    },
    onChangeTime(e) {
      if (e.length == 2) {
        this.dataForm.join_start = `${e[0]} 00:00:00`
        this.dataForm.join_end = `${e[1]} 23:59:59`
      } else {
        this.dataForm.join_start = undefined
        this.dataForm.join_end = undefined
      }
    },
    callback() {
      this.getDataList();
    },
    onSelectChange(selectedRowKeys, selectedRow) {
      console.log("selectedRowKeys changed: ", selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRow = selectedRow;
    },
    //新增共享
    addShare() {
      this.$refs.addCustomerShare.init(this.selectedRow);
    },
    addOrUpdateHandleJoin() {
      this.$http({
        url: '/admin/customer/createInviteLink',
        method: "get"
      }).then(res => {
        this.copy(res.data.invite_link)
        this.$success({
          title: '生成邀请链接成功',
          okText: "我已使用完毕，点击关闭",
          content: (
            <div>
              <p>发送给客户的链接地址：</p>
              <p>{res.data.invite_link}</p>
              <p style='color: red'>已复制到剪切板，去粘贴发送给客户吧～</p>
            </div>
          ),
        });
      })
    },
    copy(value) {
      const textarea = document.createElement('textarea');
      textarea.value = value;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      console.log('复制成功');
    }
  },
};
</script>

<style></style>